const { PRODUCT, STEP, CIVILITY } = require('./types');
const { translate} = require('../services/translate');


const verifyPNOTypeLogement = devis => {
    if (!devis.bienType) return translate('logement_type');
    if (!devis.locationDuration) return 'duration de location';
    return '';
}

const verifyMHTypeLogement = devis => {
    if (!devis.bienType) return translate('logement_type');
    if (!devis.residenceType) return translate('residence_type');
    return '';
}

const verifyPNOCharacteristics = devis => {
    if (!devis.totalRooms) return translate('recap_nb_piece');
    if (!devis.surface) return 'surface';
    if (devis.resilierContrat === null || devis.resilierContrat === undefined) return 'résiliation d\'ancien contrat';
    if (!devis.address) return translate('adresse_du_risque');
    if (!devis.zip) return translate('zip_du_risque');
    if (!devis.city) return translate('ville_du_risque');
    return '';
}

const verifyMHCharacteristics = devis => {
    if (!devis.clientType) return 'vous êtes ?';
    if (!devis.totalRooms) return translate('recap_nb_piece');
    if (!devis.surface) return 'surface';
    if (devis.resilierContrat === null || devis.resilierContrat === undefined) return 'résiliation d\'ancien contrat';
    if (!devis.address) return translate('adresse_du_risque');
    if (!devis.zip) return translate('zip_du_risque');
    if (!devis.city) return translate('ville_du_risque');
    return '';
}

const verifyMHTempoCharacteristics = devis => {
    let error = verifyMHCharacteristics(devis);
    if(error) return error;
    if(!devis.effectiveDate) return translate('date_effet');
    if(!devis.date_fin) return translate('date_fin');
}

const verifyClient = devis => {
    let client = devis.client;
    if (!client) return 'vos informations';
    if (!client.civilite) return 'civilité';
    if (client.civilite === CIVILITY.societe) {
        if (!client.raison_social) return 'Raison social';
        if (!client.firstname) return 'Prénom du représentant';
        if (!client.lastname) return 'Nom du représentant';
    } else {
        if (!client.firstname) return 'prénom';
        if (!client.lastname) return 'nom';
    }
    if (!client.email) return 'email';
    if (!client.phone) return 'téléphone';
    if (!client.address) return 'adress';
    if (!client.zip) return 'code postal';
    if (!client.city) return 'ville';
}

const validate = (devis, step, product) => {
    let isPNO = product === PRODUCT.PNO;
    let isMHTEMPO = product === PRODUCT.MH_TEMPO;

    let msg;
    switch (step) {
        case STEP.presentation:
            msg = isPNO ? verifyPNOTypeLogement(devis) : verifyMHTypeLogement(devis);
            break;
        case STEP.characteristic:
            msg = isPNO ? verifyPNOCharacteristics(devis) : 
                isMHTEMPO ? verifyMHTempoCharacteristics(devis) :
                 verifyMHCharacteristics(devis);
            break;
        case STEP.client_info:
            msg = verifyClient(devis);
            break;
        default: break;
    }
    if(msg) return translate('veuillez_remplir') + msg;
    return '';
}

module.exports = {
    validate
}